module.exports = __webpack_public_path__ + "img/lion_half.9ef10150.svg";